module.exports = __webpack_public_path__ + "static/media/401-unauthorized.54e8e4b7.svg";